module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.5e5a60bc.woff";